import { Component, OnInit } from '@angular/core';
import { NavigationServiceOpen } from './navigation.service';

import { SmartCitiesHelper } from '../objects/cities';
import { Router } from '@angular/router';
import { UserService } from '../../auth/user.service';
import { MyCityInfo } from 'app/shared/objects/cities';
import { AuthService } from '../../auth/auth.service';
import { HomeService } from 'app/public/home/home.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LanguageService, TranslatedLanguage } from '../services/language.service';
import { LanguageModalComponent } from 'app/public/language-modal/language-modal.component';
import { UserInfo } from 'app/auth/user';
import { InternationalizationService } from '../services/internationalization.service';
import { NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'ma-navigation-open',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponentOpen implements OnInit {
  user: UserInfo;
  public showMenu: boolean;
  public close: boolean;
  public bgMenu: boolean;
  public showSearch: boolean;
  public menu = true;
  search: string;
  cities: SmartCitiesHelper[];
  searchBox: boolean;
  loggedIn: boolean;
  boxsearch: boolean;
  public languages: Array<TranslatedLanguage> = [];
  private dialogRef: MatDialogRef<any, any>;

  // Multi-city support
  public myCities: MyCityInfo[] = [];
  public selectedCity: MyCityInfo = null;
  public showCitySwitcher: boolean = false;
  public showCitySearch: boolean = false;
  public citySearchTerm: string = '';
  public filteredCitiesList: MyCityInfo[] = [];

  constructor(
    public auth: AuthService,
    private navigationServiceOpen: NavigationServiceOpen,
    private internationalizationService: InternationalizationService,
    private homeService: HomeService,
    public router: Router,
    private userService: UserService,
    public dialog: MatDialog,
    public language: LanguageService
  ) {
  }

  ngOnInit(): void {
    this.loadLanguage();
    window.scrollTo(0, 0);
    this.showMenu = false;
    this.refreshUserState();

    // Re-evaluate auth/user state after redirect-based logins.
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.refreshUserState());
  }

  private refreshUserState(): void {
    this.userService.getUserInfo().then(user => {
      this.user = user;
      this.loggedIn = this.user != null && this.user.id != null;

      // Load multi-city support for PUBLIC_ADMINISTRATOR
      if (this.loggedIn && user.isPublicAdministrator()) {
        this.loadMyCities();
      }

      // redirecionar para escolher o plano caso usuário pulou a seleção de plano
      if (this.user != null && this.user.userPlan === null && !this.userService.isAdmin()) {
        let url = this.router.url.split('/');
        if (url[ 1 ] !== 'payment' && url[ 1 ] !== 'welcome') {
          // Mudança Retirada para a navegação do usuário
          // this.router.navigate(['choose-plan']);
        }
      }
    });
  }

  public changeLanguage(i: number, flag: string): void {
    const current = this.language.current();
    if (current.flag === flag) return;
    this.language.change(this.languages[ i ]);
    this.internationalizationService.changeLanguage(this.languages[ i ]);

    this.loadLanguage(i);
  }

  loadLanguage(i?: number): void {
    this.internationalizationService.getLanguages().then((data: TranslatedLanguage[]) => {

      if (data[ 'count' ]) {
        this.languages = data[ 'items' ];
        if (i != null) {
          this.language.saveCookie(this.languages[ i ]);
          this.language.change(this.languages[ i ]);
          // window.location.reload();
        }
      }
    });
  }

  isAdmin() {
    return this.userService.isAdmin();
  }

  menuToggle() {
    this.showMenu = !this.showMenu;
  }

  toggleHamburgerMenu(): void {
    this.navigationServiceOpen.toggleHamburgerMenu();
  }

  hideHamburgerMenu(): void {
    this.navigationServiceOpen.hideHamburgerMenu();
  }

  goToCity(slug: string, id: string) {
    window.scrollTo(0, 0);
    this.router.navigate(['/smart-city-profile', slug, id]);
  }

  searchCities() {
    setTimeout(() => {
      this.homeService.getSearchSmartCities(this.search)
        .then(response => this.cities = response);
      this.searchBox = true;
    }, 300);
  }

  focusSearch() {
    this.showSearch = true;
    this.boxsearch = true;
  }

  blurSearch() {
    setTimeout(() => {
      this.showSearch = false;
      this.boxsearch = false;
    }, 500);
  }

  logoutUser() {
    this.userService.clearUserCache();
    this.loggedIn = false;
    this.user = new UserInfo;
    this.auth.logout();
  }

  openLanguageModal(): void {
    if (this.dialogRef == undefined) {
      this.dialogRef = this.dialog.open(LanguageModalComponent, {});

      this.dialogRef.afterClosed().subscribe(result => {
        this.dialogRef = result;
      });
    } else {
      this.dialog.closeAll();
      this.dialogRef = undefined;
    }
  }

  onLogin(): void {
    window.localStorage.history = window.location.pathname;
    window.localStorage.setItem('retornar', window.location.pathname);
    this.router.navigate(['login']);
  }

  // Multi-city support methods
  private async loadMyCities(): Promise<void> {
    const cities = await this.userService.getMyCities();
    this.myCities = cities || [];
    this.filteredCitiesList = [...this.myCities];
    this.showCitySwitcher = this.myCities.length > 1;

    // Set initial selected city
    const selectedCityId = await this.userService.getSelectedCityId();
    this.selectedCity = this.myCities.find(c => c.id === selectedCityId) || this.myCities[0];
  }

  public filterCitiesInput(): void {
    const term = this.citySearchTerm.toLowerCase().trim();
    if (!term) {
      this.filteredCitiesList = [...this.myCities];
    } else {
      this.filteredCitiesList = this.myCities.filter(city =>
        city.name.toLowerCase().includes(term) ||
        (city.region && city.region.toLowerCase().includes(term)) ||
        (city.country && city.country.toLowerCase().includes(term))
      );
    }
  }

  public focusCitySearch(): void {
    this.showCitySearch = true;
    this.filteredCitiesList = [...this.myCities];
    this.citySearchTerm = '';
  }

  public blurCitySearch(): void {
    setTimeout(() => {
      this.showCitySearch = false;
    }, 200);
  }

  public selectCity(city: MyCityInfo): void {
    this.selectedCity = city;
    this.userService.setSelectedCity(city.id);
    this.showCitySearch = false;
    this.citySearchTerm = '';

    this.router.navigate(['/smart-city-profile/public-profile', city.id]);
  }

  public onCityChange(city: MyCityInfo): void {
    this.selectCity(city);
  }

  public getSelectedCityId(): string {
    return this.selectedCity?.id || this.user?.cityId;
  }
}
